import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";
import { API_ENDPOINTS } from "../constants/constants";

export const searchBranches = async (name) => {
  const query = new URLSearchParams({ name }).toString();
  const endpoint = `${API_ENDPOINTS.SEARCH_BRANCHES}?${query}`;

  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  };

  const response = await fetchJSON(endpoint, options);
  return response?.branches;
};

export const useSearchBranches = () => {
  return useMutation({
    mutationFn: searchBranches,
  });
};
